import React from 'react';
import PropTypes from 'prop-types';
import { ActivityDropdown, LocationDropdown } from 'shared-components/search-module';
import withCustomInputHoc from '../elements-inputs/custom-input-hoc';
import { FormBuilder } from 'shared-components/forms/form';
import withActivityDropdownHoc from '../elements-search-module/activity-dropdown-hoc-nav';
import withLocationDropdownHoc from '../elements-search-module/location-dropdown-hoc-nav';
import { injectIntl } from 'react-intl';

const ActivityDropdownCustom = withCustomInputHoc(withActivityDropdownHoc(ActivityDropdown));
const LocationDropdownCustom = withCustomInputHoc(withLocationDropdownHoc(LocationDropdown));

class SearchFormNav extends React.Component {
  constructor (props) {
    super(props);

    this.inputRefs = {};

    this.state = {
      isSearchDisabled: false
    };

    this.toggleSearchDisable = this.toggleSearchDisable.bind(this);
    this.localSubmitCallback = this.localSubmitCallback.bind(this);
  }

  toggleSearchDisable (flag, callback) {
    this.setState({
      isSearchDisabled: flag
    }, () => {
      if ('function' === typeof callback) {
        callback();
      }
    });
  }

  localSubmitCallback (value) {
    this.props.submitCallback(value, this.state.isSearchDisabled);
  }

  render () {
    const formInputs = [
      {
        custom:
          <div className="col-xs-offset-1 col-xs-10 margin-md-bottom no-gutter">
            <ActivityDropdownCustom
              ref={ref => { this.inputRefs.activity = ref; }}
              activityRef={ref => {
                if ('function' === typeof this.props.dropdownRefs) this.props.dropdownRefs(ref, 'activityRef');
              }} // this ref will allow us to toggle the dropdown
              inputFieldName="activity"
              inputClassName="normalize-inputs"
              selectedFilters={{ useTypeObj: this.props.dropdown, useTypeId: this.props.dropdownId }}
              optional
            />
          </div>
      },
      {
        custom:
          <div className="col-xs-offset-1 col-xs-10 margin-md-bottom no-gutter">
            <LocationDropdownCustom
              ref={ref => { this.inputRefs.location = ref; }}
              toggleSearchDisable={this.toggleSearchDisable}
              locationRef={ref => {
                if ('function' === typeof this.props.dropdownRefs) this.props.dropdownRefs(ref, 'locationRef');
              }} // this ref will allow us to toggle the dropdown
              inputFieldName="location"
              inputClassName="normalize-inputs"
              optional
            />
          </div>
      }
    ];
    return (
      <div className="search-form-nav">
        <FormBuilder
          errorText=""
          inputRefs={this.inputRefs}
          formname="nav-search-module"
          formStyle="standard"
          formInputs={formInputs}
          formClassString="col-lg-12 no-gutter"
          submitAction={this.props.submitAction}
          submitCallback={this.localSubmitCallback}
          buttonText={ this.props.intl.formatMessage({ id: 'boards.search_from_nav.search', defaultMessage: 'Search' }) }
          btnColSize="col-xs-offset-1 col-xs-10 no-gutter"
          buttonClass="btn btn-lg btn-block btn-primary form force-button"
          optionalButtonAttributes={{ 'data-testing-id': 'nav-search' }}
        />
      </div>
    );
  }
}

SearchFormNav.propTypes = {
  dropdown: PropTypes.string,
  dropdownId: PropTypes.string,
  submitAction: PropTypes.func,
  submitCallback: PropTypes.func,
  dropdownRefs: PropTypes.func
};

exports.SearchFormNav = injectIntl(SearchFormNav);
